/** Wei -> "0.001" (up to 6 decimals, trailing zeros trimmed). */
export const fmtEth = (wei: bigint): string => (Number(wei) / 1e18).toFixed(6).replace(/\.?0+$/, '');
